import { __assign } from "tslib";
import { tokensLegion } from './tokens';
// Default Themes
export var legionTheme = {
    name: 'legion',
    tokens: tokensLegion
};
var mergeJSON = function (obj, prefix) {
    if (obj === void 0) { obj = {}; }
    if (prefix === void 0) { prefix = ''; }
    var result = {};
    for (var key in obj) {
        var newPrefix = prefix
            ? prefix === 'colors'
                ? key
                : "".concat(prefix).concat(key.charAt(0).toUpperCase() + key.slice(1))
            : key;
        var removeSuffixValue = newPrefix.replace('Value', '');
        if (typeof obj[key] === 'object') {
            var nested = mergeJSON(obj[key], removeSuffixValue);
            Object.assign(result, nested);
        }
        else {
            if (key === 'value') {
                var value = obj[key].replace(/{|}|-|\./g, '').toLowerCase();
                result[removeSuffixValue] = value;
            }
        }
    }
    return result;
};
export var createTokens = function (_a) {
    var apiUrl = _a.apiUrl, apiHeaders = _a.apiHeaders, tokensName = _a.tokensName, _b = _a.tokensDefault, tokensDefault = _b === void 0 ? tokensLegion : _b;
    var getTokens = typeof window !== 'undefined' ? localStorage.getItem(tokensName) : null;
    var result = getTokens ? __assign(__assign({}, tokensDefault), JSON.parse(getTokens)) : __assign({}, tokensDefault);
    fetch(apiUrl, {
        method: 'GET',
        headers: apiHeaders
    })
        .then(function (response) { return response.json(); })
        .then(function (data) {
        var tokens = mergeJSON(data);
        // change baseWhite to be basewhite
        tokens['basewhite'] = tokens['baseWhite'];
        delete tokens['baseWhite'];
        // change baseBlack to be baseblack
        tokens['baseBlack'] = tokens['baseblack'];
        delete tokens['baseBlack'];
        for (var key in tokens) {
            if (tokens[key] in tokens) {
                tokens[key] = tokens[tokens[key]];
            }
        }
        result = __assign({}, tokens);
        if (typeof window !== 'undefined') {
            localStorage.setItem(tokensName, JSON.stringify(tokens));
        }
    });
    return result;
};
